import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { showToast } from "../../utils/toast";
import { InputField } from "../../components/form/InputField";
import { postRequest } from "../../hooks/services/services";
import CommonModal from "../modal/CommonModal";

const VerifyCode = ({email, type, onNext }) => {
  const [secondsLeft, setSecondsLeft] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [showResetModal, setShowResetModal] = useState(false);
  const [emailForVerification, setEmailForVerification] = useState("");

  
  useEffect(() => {
    setCanResend(false);
    setSecondsLeft(60);
    const interval = setInterval(() => {
      setSecondsLeft((prev) => {
        if (prev === 1) {
          clearInterval(interval);
          setCanResend(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const schema = Yup.object().shape({
    verifyCode: Yup.string().required("Field is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

const resendOTP = async () => {
    if (!canResend) return; 
    const payload = { email, type };
    const response = await postRequest("api/v1/otps/resend_otp", payload);
    if (response.status === 200) {
      let responseData = await response.json();
      showToast(responseData?.message, "success");
      // Restart timer
      setSecondsLeft(60);
      setCanResend(false);
      const interval = setInterval(() => {
        setSecondsLeft((prev) => {
          if (prev === 1) {
            clearInterval(interval);
            setCanResend(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };


  const onSubmit = async (data) => {
    try {
      const payload = {
        email: email,
        otp: data?.verifyCode,
        type: type,
      };
      const response = await postRequest("api/v1/otps/verify_otp", payload);
      if (response.status === 200) {
        let responseData = await response.json();
        showToast(responseData?.message, "success");
        setEmailForVerification(email);
        setShowResetModal(true);
        onNext();
      }
    } catch (error) {
      showToast(error.message, "error");
    }
  };
  return (
    <div>
      <section class="form_part space-cmn">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="signupTab">
                <div class="formArea border-radius-20 border-gray">
                  <p class="text-center mb-4">
                    We've sent a code to <span class="text-primary">{email}</span>
                  </p>
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div class="row g-4">
                      <div class="col-md-12">
                        <div class="form-group">
                          <label>
                            Verification code: <span class="text-danger">*</span>
                          </label>
                          <InputField
                            type="text"
                            register={register}
                            name="verifyCode"
                            error={errors?.verifyCode?.message}
                          />
                        </div>
                      </div>
                      <div class="col-md-12">
                        <button type="submit" class="black_btn">
                          Verify Code
                        </button>
                      </div>

                      <div className="col-md-12">
                        <span
                          className={`forgot text_decor d-flex justify-content-end ${!canResend ? "disabled-link" : ""}`}
                          onClick={canResend ? resendOTP : null}
                          style={{
                            cursor: canResend ? "pointer" : "not-allowed",
                            color: canResend ? "gray" : "gray",
                          }}
                        >
                          {canResend ? "Send OTP Again" : `Resend in 0:${secondsLeft < 10 ? `0${secondsLeft}` : secondsLeft}`}
                        </span>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CommonModal
        modelOpen={showResetModal}
        setModelOpen={setShowResetModal}
        headerContent="Reset Password"
        modalType={{ name: "resetPassword", email: emailForVerification, type: type }}
      />
    </div>
  );
};
export default VerifyCode;
